// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteAccountsDeleteData, DeleteAccountsDeleteResponses, DeleteIdentityCryptoDeleteCredentialData, DeleteIdentityCryptoDeleteCredentialResponses, DeleteIdentityDeleteFingerprintsData, DeleteIdentityDeleteFingerprintsResponses, DeleteIdentityDeletePasskeyData, DeleteIdentityDeletePasskeyResponses, DeleteIdentityDeleteTotpData, DeleteIdentityDeleteTotpResponses, DeleteMobileDevicesRemoveData, DeleteMobileDevicesRemoveResponses, DeleteRolesDeleteData, DeleteRolesDeleteResponses, DeleteSaPermissionBoundarySetsRemoveData, DeleteSaPermissionBoundarySetsRemoveResponses, DeleteSaTenantsDeleteData, DeleteSaTenantsDeleteResponses, DeleteScopedTokensRevokeData, DeleteScopedTokensRevokeResponses, DeleteTenantApiKeysRemoveData, DeleteTenantApiKeysRemoveResponses, DeleteTenantIdentityCryptoRevokeAuthorityGrantData, DeleteTenantIdentityCryptoRevokeAuthorityGrantResponses, DeleteTenantIdentityCryptoRevokeCertificateData, DeleteTenantIdentityCryptoRevokeCertificateResponses, DeleteTenantPublishableKeysRemoveData, DeleteTenantPublishableKeysRemoveResponses, DeleteWorkstationsRemoveData, DeleteWorkstationsRemoveResponses, GetAccountsListData, GetAccountsListResponses, GetAccountsLookupData, GetAccountsLookupResponses, GetAuditIndexData, GetAuditIndexResponses, GetAuthAuthzData, GetAuthAuthzResponses, GetIdentityCryptoAccountIdentityData, GetIdentityCryptoAccountIdentityResponses, GetIdentityCryptoCertificateData, GetIdentityCryptoCertificateResponses, GetIdentityCryptoListCredentialsData, GetIdentityCryptoListCredentialsResponses, GetIdentityCryptoWrappedKeysData, GetIdentityCryptoWrappedKeysResponses, GetIdentityGetFingerprintsData, GetIdentityGetFingerprintsResponses, GetIdentityGetIdentityData, GetIdentityGetIdentityResponses, GetIdentityGetPasskeysData, GetIdentityGetPasskeysResponses, GetIdpConfigGetIdpConfigData, GetIdpConfigGetIdpConfigResponses, GetIdpListAccountsData, GetIdpListAccountsResponses, GetLoginReauthenticationOptionsData, GetLoginReauthenticationOptionsResponses, GetLoginSsoDirectCallbackData, GetLoginSsoDirectCallbackResponses, GetMobileDevicesIndexData, GetMobileDevicesIndexResponses, GetMobileDevicesSessionData, GetMobileDevicesSessionResponses, GetMspGetMspTenantsData, GetMspGetMspTenantsResponses, GetOidcDiscoveryGetJwksData, GetOidcDiscoveryGetJwksResponses, GetOidcDiscoveryGetOidcConfigurationData, GetOidcDiscoveryGetOidcConfigurationResponses, GetPermissionsGetData, GetPermissionsGetResponses, GetProxyOidcCallbackData, GetProxyOidcCallbackResponses, GetPublicMspGetMspInfoData, GetPublicMspGetMspInfoResponses, GetRolesListData, GetRolesListResponses, GetSaAccountsGetData, GetSaAccountsGetResponses, GetSaPermissionBoundariesGetCatalogData, GetSaPermissionBoundariesGetCatalogResponses, GetSaPermissionBoundarySetsGetData, GetSaPermissionBoundarySetsGetResponses, GetSaPermissionBoundarySetsHistoryData, GetSaPermissionBoundarySetsHistoryResponses, GetSaPermissionBoundarySetsListData, GetSaPermissionBoundarySetsListResponses, GetSaTenantPermissionBoundaryGetData, GetSaTenantPermissionBoundaryGetResponses, GetSaTenantPermissionBoundaryHistoryData, GetSaTenantPermissionBoundaryHistoryResponses, GetSaTenantsGetData, GetSaTenantsGetResponses, GetSaTenantsListData, GetSaTenantsListResponses, GetScopedTokensListData, GetScopedTokensListResponses, GetSseGetStreamData, GetSseGetStreamResponses, GetTenantApiKeysListData, GetTenantApiKeysListResponses, GetTenantGetConfigData, GetTenantGetConfigResponses, GetTenantGetData, GetTenantGetResponses, GetTenantIdentityCryptoListAuthorityGrantsData, GetTenantIdentityCryptoListAuthorityGrantsResponses, GetTenantIdentityCryptoListCertificatesData, GetTenantIdentityCryptoListCertificatesResponses, GetTenantIdentityCryptoRecoveryData, GetTenantIdentityCryptoRecoveryResponses, GetTenantIdentityCryptoStatusData, GetTenantIdentityCryptoStatusResponses, GetTenantPublishableKeysListData, GetTenantPublishableKeysListResponses, GetWorkstationsIndexData, GetWorkstationsIndexResponses, GetWorkstationsResolveNamesData, GetWorkstationsResolveNamesResponses, PatchIdentityCryptoUpdateCredentialLabelData, PatchIdentityCryptoUpdateCredentialLabelResponses, PatchSaTenantPermissionBoundaryPatchData, PatchSaTenantPermissionBoundaryPatchResponses, PostAccountsCreateData, PostAccountsCreateResponses, PostAccountsForceLogoutData, PostAccountsForceLogoutResponses, PostBrowserAckNotificationData, PostBrowserAckNotificationResponses, PostBrowserDeidleData, PostBrowserDeidleResponses, PostDebugSendNotificationData, PostDebugSendNotificationResponses, PostDebugSendSseData, PostDebugSendSseResponses, PostIdentifyByCredentialsData, PostIdentifyByCredentialsResponses, PostIdentifyByFingerprintData, PostIdentifyByFingerprintResponses, PostIdentityCryptoAuthorizeResetData, PostIdentityCryptoAuthorizeResetResponses, PostIdentityCryptoRegisterCredentialData, PostIdentityCryptoRegisterCredentialResponses, PostIdentityCryptoRequestRenewalData, PostIdentityCryptoRequestRenewalForAccountData, PostIdentityCryptoRequestRenewalForAccountResponses, PostIdentityCryptoRequestRenewalResponses, PostIdentityCryptoResetIdentityData, PostIdentityCryptoResetIdentityResponses, PostIdentityEnrollFingerprintData, PostIdentityEnrollFingerprintResponses, PostIdentityPasskeyRegistrationOptionsData, PostIdentityPasskeyRegistrationOptionsResponses, PostIdentityTotpEnrollmentOptionsData, PostIdentityTotpEnrollmentOptionsResponses, PostIdentityVerifyPasskeyRegistrationData, PostIdentityVerifyPasskeyRegistrationResponses, PostIdentityVerifyTotpEnrollmentData, PostIdentityVerifyTotpEnrollmentResponses, PostIdpConfigCompleteIdpSetupData, PostIdpConfigCompleteIdpSetupResponses, PostIdpConfigSetupIdpConfigData, PostIdpConfigSetupIdpConfigResponses, PostIdpConfigUnlinkIdpData, PostIdpConfigUnlinkIdpResponses, PostIdpImportMatchedAccountsData, PostIdpImportMatchedAccountsResponses, PostLoginDeviceLoginData, PostLoginDeviceLoginResponses, PostLoginDevicePasswordLoginData, PostLoginDevicePasswordLoginResponses, PostLoginLoginData, PostLoginLoginResponses, PostLoginLogoutData, PostLoginLogoutResponses, PostLoginOneTimeLoginData, PostLoginOneTimeLoginResponses, PostLoginPasskeyOptionsData, PostLoginPasskeyOptionsResponses, PostLoginPasskeyVerifyData, PostLoginPasskeyVerifyResponses, PostLoginPasswordLoginData, PostLoginPasswordLoginResponses, PostLoginReauthenticatePasskeyData, PostLoginReauthenticatePasskeyOptionsData, PostLoginReauthenticatePasskeyOptionsResponses, PostLoginReauthenticatePasskeyResponses, PostLoginReauthenticatePasswordData, PostLoginReauthenticatePasswordResponses, PostLoginReauthenticateSsoData, PostLoginReauthenticateSsoResponses, PostLoginReauthenticateTotpData, PostLoginReauthenticateTotpResponses, PostLoginRenewData, PostLoginRenewResponses, PostLoginSsoCallbackData, PostLoginSsoCallbackResponses, PostLoginTotpLoginData, PostLoginTotpLoginResponses, PostMobileDevicesCreateRegistrationData, PostMobileDevicesCreateRegistrationResponses, PostMobileDevicesLoginData, PostMobileDevicesLoginResponses, PostMobileDevicesLogoutData, PostMobileDevicesLogoutResponses, PostMobileDevicesRegisterData, PostMobileDevicesRegisterResponses, PostProxyOidcGenerateStartUrlData, PostProxyOidcGenerateStartUrlResponses, PostProxyOidcRenewData, PostProxyOidcRenewResponses, PostProxyOidcStartData, PostProxyOidcStartResponses, PostPushTokenRegisterPushTokenData, PostPushTokenRegisterPushTokenResponses, PostRolesCreateData, PostRolesCreateResponses, PostRpcSignRpcPayloadData, PostRpcSignRpcPayloadResponses, PostSaPermissionBoundarySetsCreateData, PostSaPermissionBoundarySetsCreateResponses, PostSaTenantPermissionBoundaryApplySetData, PostSaTenantPermissionBoundaryApplySetResponses, PostSaTenantsCreateData, PostSaTenantsCreateResponses, PostScopedTokensCreateData, PostScopedTokensCreateResponses, PostScopedTokensRenewData, PostScopedTokensRenewResponses, PostScopedTokensRevokeSelfData, PostScopedTokensRevokeSelfResponses, PostTenantApiKeysCreateData, PostTenantApiKeysCreateResponses, PostTenantAssociateMspData, PostTenantAssociateMspResponses, PostTenantIdentityCryptoClaimRenewalData, PostTenantIdentityCryptoClaimRenewalResponses, PostTenantIdentityCryptoCompleteRenewalData, PostTenantIdentityCryptoCompleteRenewalResponses, PostTenantIdentityCryptoGrantData, PostTenantIdentityCryptoGrantResponses, PostTenantIdentityCryptoInitializeData, PostTenantIdentityCryptoInitializeResponses, PostTenantIdentityCryptoIssueCertificateData, PostTenantIdentityCryptoIssueCertificateResponses, PostTenantPublishableKeysCreateData, PostTenantPublishableKeysCreateResponses, PostWorkstationsAuthCredentialsData, PostWorkstationsAuthCredentialsResponses, PostWorkstationsAuthFpData, PostWorkstationsAuthFpResponses, PostWorkstationsCreateData, PostWorkstationsCreateRegistrationData, PostWorkstationsCreateRegistrationResponses, PostWorkstationsCreateResponses, PostWorkstationsDetectWorkstationData, PostWorkstationsDetectWorkstationResponses, PostWorkstationsRegisterData, PostWorkstationsRegisterResponses, PostZynoRpcDispatchData, PostZynoRpcDispatchResponses, PutAccountsUpdateData, PutAccountsUpdatePermissionsData, PutAccountsUpdatePermissionsResponses, PutAccountsUpdateResponses, PutIdentityCryptoStoreWrappedKeysData, PutIdentityCryptoStoreWrappedKeysResponses, PutIdentitySetPasswordData, PutIdentitySetPasswordResponses, PutMobileDevicesUpdateData, PutMobileDevicesUpdateResponses, PutRolesUpdateData, PutRolesUpdatePermissionsData, PutRolesUpdatePermissionsResponses, PutRolesUpdateResponses, PutSaAccountsSetSessionLimitsData, PutSaAccountsSetSessionLimitsResponses, PutSaPermissionBoundarySetsUpdateData, PutSaPermissionBoundarySetsUpdateResponses, PutSaTenantPermissionBoundaryReplaceData, PutSaTenantPermissionBoundaryReplaceResponses, PutSaTenantsUpdateData, PutSaTenantsUpdateResponses, PutTenantApiKeysUpdateData, PutTenantApiKeysUpdateResponses, PutTenantPublishableKeysUpdateData, PutTenantPublishableKeysUpdateResponses, PutTenantUpdateConfigData, PutTenantUpdateConfigResponses, PutWorkstationsUpdateData, PutWorkstationsUpdateResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class AuthAuditApi {
    public static getAuditIndex<ThrowOnError extends boolean = false>(options?: Options<GetAuditIndexData, ThrowOnError>): RequestResult<GetAuditIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetAuditIndexResponses, unknown, ThrowOnError>({ url: '/audit', ...options });
    }
}

export class AuthBrowserApi {
    public static postBrowserDeidle<ThrowOnError extends boolean = false>(options?: Options<PostBrowserDeidleData, ThrowOnError>): RequestResult<PostBrowserDeidleResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostBrowserDeidleResponses, unknown, ThrowOnError>({ url: '/browser/deidle', ...options });
    }
    
    public static postBrowserAckNotification<ThrowOnError extends boolean = false>(options: Options<PostBrowserAckNotificationData, ThrowOnError>): RequestResult<PostBrowserAckNotificationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostBrowserAckNotificationResponses, unknown, ThrowOnError>({ url: '/browser/notification/{notificationId}/ack', ...options });
    }
}

export class AuthDebugApi {
    public static postDebugSendSse<ThrowOnError extends boolean = false>(options: Options<PostDebugSendSseData, ThrowOnError>): RequestResult<PostDebugSendSseResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDebugSendSseResponses, unknown, ThrowOnError>({
            url: '/debug/sse',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDebugSendNotification<ThrowOnError extends boolean = false>(options: Options<PostDebugSendNotificationData, ThrowOnError>): RequestResult<PostDebugSendNotificationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDebugSendNotificationResponses, unknown, ThrowOnError>({
            url: '/debug/notification',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthLoginApi {
    public static postLoginLogin<ThrowOnError extends boolean = false>(options: Options<PostLoginLoginData, ThrowOnError>): RequestResult<PostLoginLoginResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostLoginLoginResponses, unknown, ThrowOnError>({
            url: '/login',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postLoginDeviceLogin<ThrowOnError extends boolean = false>(options: Options<PostLoginDeviceLoginData, ThrowOnError>): RequestResult<PostLoginDeviceLoginResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostLoginDeviceLoginResponses, unknown, ThrowOnError>({
            url: '/login/device',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postLoginDevicePasswordLogin<ThrowOnError extends boolean = false>(options: Options<PostLoginDevicePasswordLoginData, ThrowOnError>): RequestResult<PostLoginDevicePasswordLoginResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostLoginDevicePasswordLoginResponses, unknown, ThrowOnError>({
            url: '/login/device/password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postLoginPasswordLogin<ThrowOnError extends boolean = false>(options: Options<PostLoginPasswordLoginData, ThrowOnError>): RequestResult<PostLoginPasswordLoginResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostLoginPasswordLoginResponses, unknown, ThrowOnError>({
            url: '/login/password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postLoginOneTimeLogin<ThrowOnError extends boolean = false>(options: Options<PostLoginOneTimeLoginData, ThrowOnError>): RequestResult<PostLoginOneTimeLoginResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostLoginOneTimeLoginResponses, unknown, ThrowOnError>({
            url: '/login/one-time',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postLoginPasskeyOptions<ThrowOnError extends boolean = false>(options: Options<PostLoginPasskeyOptionsData, ThrowOnError>): RequestResult<PostLoginPasskeyOptionsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostLoginPasskeyOptionsResponses, unknown, ThrowOnError>({
            url: '/login/passkey/options',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postLoginPasskeyVerify<ThrowOnError extends boolean = false>(options: Options<PostLoginPasskeyVerifyData, ThrowOnError>): RequestResult<PostLoginPasskeyVerifyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostLoginPasskeyVerifyResponses, unknown, ThrowOnError>({
            url: '/login/passkey/verify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postLoginTotpLogin<ThrowOnError extends boolean = false>(options: Options<PostLoginTotpLoginData, ThrowOnError>): RequestResult<PostLoginTotpLoginResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostLoginTotpLoginResponses, unknown, ThrowOnError>({
            url: '/login/totp',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postLoginSsoCallback<ThrowOnError extends boolean = false>(options: Options<PostLoginSsoCallbackData, ThrowOnError>): RequestResult<PostLoginSsoCallbackResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostLoginSsoCallbackResponses, unknown, ThrowOnError>({
            url: '/login/sso',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getLoginSsoDirectCallback<ThrowOnError extends boolean = false>(options: Options<GetLoginSsoDirectCallbackData, ThrowOnError>): RequestResult<GetLoginSsoDirectCallbackResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetLoginSsoDirectCallbackResponses, unknown, ThrowOnError>({ url: '/login/sso-callback', ...options });
    }
    
    public static postLoginRenew<ThrowOnError extends boolean = false>(options: Options<PostLoginRenewData, ThrowOnError>): RequestResult<PostLoginRenewResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostLoginRenewResponses, unknown, ThrowOnError>({
            url: '/login/renew',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postLoginLogout<ThrowOnError extends boolean = false>(options?: Options<PostLoginLogoutData, ThrowOnError>): RequestResult<PostLoginLogoutResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostLoginLogoutResponses, unknown, ThrowOnError>({ url: '/login/logout', ...options });
    }
    
    public static getLoginReauthenticationOptions<ThrowOnError extends boolean = false>(options?: Options<GetLoginReauthenticationOptionsData, ThrowOnError>): RequestResult<GetLoginReauthenticationOptionsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetLoginReauthenticationOptionsResponses, unknown, ThrowOnError>({ url: '/login/reauthentication', ...options });
    }
    
    public static postLoginReauthenticatePassword<ThrowOnError extends boolean = false>(options: Options<PostLoginReauthenticatePasswordData, ThrowOnError>): RequestResult<PostLoginReauthenticatePasswordResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostLoginReauthenticatePasswordResponses, unknown, ThrowOnError>({
            url: '/login/reauthentication/password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postLoginReauthenticateTotp<ThrowOnError extends boolean = false>(options: Options<PostLoginReauthenticateTotpData, ThrowOnError>): RequestResult<PostLoginReauthenticateTotpResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostLoginReauthenticateTotpResponses, unknown, ThrowOnError>({
            url: '/login/reauthentication/totp',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postLoginReauthenticatePasskeyOptions<ThrowOnError extends boolean = false>(options?: Options<PostLoginReauthenticatePasskeyOptionsData, ThrowOnError>): RequestResult<PostLoginReauthenticatePasskeyOptionsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostLoginReauthenticatePasskeyOptionsResponses, unknown, ThrowOnError>({ url: '/login/reauthentication/passkey/options', ...options });
    }
    
    public static postLoginReauthenticatePasskey<ThrowOnError extends boolean = false>(options: Options<PostLoginReauthenticatePasskeyData, ThrowOnError>): RequestResult<PostLoginReauthenticatePasskeyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostLoginReauthenticatePasskeyResponses, unknown, ThrowOnError>({
            url: '/login/reauthentication/passkey/verify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postLoginReauthenticateSso<ThrowOnError extends boolean = false>(options: Options<PostLoginReauthenticateSsoData, ThrowOnError>): RequestResult<PostLoginReauthenticateSsoResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostLoginReauthenticateSsoResponses, unknown, ThrowOnError>({
            url: '/login/reauthentication/sso',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthMobileDevicesApi {
    /**
     * // ----- admin endpoints (account JWT) -----
     */
    public static getMobileDevicesIndex<ThrowOnError extends boolean = false>(options?: Options<GetMobileDevicesIndexData, ThrowOnError>): RequestResult<GetMobileDevicesIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetMobileDevicesIndexResponses, unknown, ThrowOnError>({ url: '/mobile-devices', ...options });
    }
    
    /**
     * Create a pending shared-device enrolment and return a short registration code for the device to redeem.
     */
    public static postMobileDevicesCreateRegistration<ThrowOnError extends boolean = false>(options: Options<PostMobileDevicesCreateRegistrationData, ThrowOnError>): RequestResult<PostMobileDevicesCreateRegistrationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostMobileDevicesCreateRegistrationResponses, unknown, ThrowOnError>({
            url: '/mobile-devices',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Remove a shared device: soft-delete it, kill the active session, and notify admins.
     */
    public static deleteMobileDevicesRemove<ThrowOnError extends boolean = false>(options: Options<DeleteMobileDevicesRemoveData, ThrowOnError>): RequestResult<DeleteMobileDevicesRemoveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteMobileDevicesRemoveResponses, unknown, ThrowOnError>({ url: '/mobile-devices/{id}', ...options });
    }
    
    /**
     * Adjust a shared device's idle timeout (seconds of inactivity before the logged-in account is auto-cleared). `null` disables the timeout; otherwise it must be between MIN and MAX. Shared devices only.
     */
    public static putMobileDevicesUpdate<ThrowOnError extends boolean = false>(options: Options<PutMobileDevicesUpdateData, ThrowOnError>): RequestResult<PutMobileDevicesUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutMobileDevicesUpdateResponses, unknown, ThrowOnError>({
            url: '/mobile-devices/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * // ----- device endpoints (device-only ZMDA, or code for register) -----
     */
    public static postMobileDevicesRegister<ThrowOnError extends boolean = false>(options: Options<PostMobileDevicesRegisterData, ThrowOnError>): RequestResult<PostMobileDevicesRegisterResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostMobileDevicesRegisterResponses, unknown, ThrowOnError>({
            url: '/mobile-devices/register',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * An account signs into the shared device with its ZW accountName/password. Replaces any prior account.
     */
    public static postMobileDevicesLogin<ThrowOnError extends boolean = false>(options: Options<PostMobileDevicesLoginData, ThrowOnError>): RequestResult<PostMobileDevicesLoginResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostMobileDevicesLoginResponses, unknown, ThrowOnError>({
            url: '/mobile-devices/login',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * The device clears the current account session. Idempotent — a no-op if nobody is signed in.
     */
    public static postMobileDevicesLogout<ThrowOnError extends boolean = false>(options?: Options<PostMobileDevicesLogoutData, ThrowOnError>): RequestResult<PostMobileDevicesLogoutResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostMobileDevicesLogoutResponses, unknown, ThrowOnError>({ url: '/mobile-devices/logout', ...options });
    }
    
    /**
     * Boot/reconnect reconciliation + liveness heartbeat. Resolves even for a removed device so it can be told.
     */
    public static getMobileDevicesSession<ThrowOnError extends boolean = false>(options?: Options<GetMobileDevicesSessionData, ThrowOnError>): RequestResult<GetMobileDevicesSessionResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetMobileDevicesSessionResponses, unknown, ThrowOnError>({ url: '/mobile-devices/session', ...options });
    }
}

export class AuthIdentifyApi {
    public static postIdentifyByCredentials<ThrowOnError extends boolean = false>(options: Options<PostIdentifyByCredentialsData, ThrowOnError>): RequestResult<PostIdentifyByCredentialsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostIdentifyByCredentialsResponses, unknown, ThrowOnError>({
            url: '/identify/by-credentials',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postIdentifyByFingerprint<ThrowOnError extends boolean = false>(options: Options<PostIdentifyByFingerprintData, ThrowOnError>): RequestResult<PostIdentifyByFingerprintResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostIdentifyByFingerprintResponses, unknown, ThrowOnError>({
            url: '/identify/by-fingerprint',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthIdentityApi {
    public static getIdentityGetIdentity<ThrowOnError extends boolean = false>(options?: Options<GetIdentityGetIdentityData, ThrowOnError>): RequestResult<GetIdentityGetIdentityResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetIdentityGetIdentityResponses, unknown, ThrowOnError>({ url: '/identity', ...options });
    }
    
    public static putIdentitySetPassword<ThrowOnError extends boolean = false>(options: Options<PutIdentitySetPasswordData, ThrowOnError>): RequestResult<PutIdentitySetPasswordResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutIdentitySetPasswordResponses, unknown, ThrowOnError>({
            url: '/identity/password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getIdentityGetPasskeys<ThrowOnError extends boolean = false>(options?: Options<GetIdentityGetPasskeysData, ThrowOnError>): RequestResult<GetIdentityGetPasskeysResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetIdentityGetPasskeysResponses, unknown, ThrowOnError>({ url: '/identity/passkeys', ...options });
    }
    
    public static postIdentityPasskeyRegistrationOptions<ThrowOnError extends boolean = false>(options?: Options<PostIdentityPasskeyRegistrationOptionsData, ThrowOnError>): RequestResult<PostIdentityPasskeyRegistrationOptionsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostIdentityPasskeyRegistrationOptionsResponses, unknown, ThrowOnError>({ url: '/identity/passkeys/options', ...options });
    }
    
    public static postIdentityVerifyPasskeyRegistration<ThrowOnError extends boolean = false>(options: Options<PostIdentityVerifyPasskeyRegistrationData, ThrowOnError>): RequestResult<PostIdentityVerifyPasskeyRegistrationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostIdentityVerifyPasskeyRegistrationResponses, unknown, ThrowOnError>({
            url: '/identity/passkeys/verify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteIdentityDeletePasskey<ThrowOnError extends boolean = false>(options: Options<DeleteIdentityDeletePasskeyData, ThrowOnError>): RequestResult<DeleteIdentityDeletePasskeyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteIdentityDeletePasskeyResponses, unknown, ThrowOnError>({ url: '/identity/passkeys/{credentialId}', ...options });
    }
    
    public static postIdentityTotpEnrollmentOptions<ThrowOnError extends boolean = false>(options?: Options<PostIdentityTotpEnrollmentOptionsData, ThrowOnError>): RequestResult<PostIdentityTotpEnrollmentOptionsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostIdentityTotpEnrollmentOptionsResponses, unknown, ThrowOnError>({ url: '/identity/totp/options', ...options });
    }
    
    public static postIdentityVerifyTotpEnrollment<ThrowOnError extends boolean = false>(options: Options<PostIdentityVerifyTotpEnrollmentData, ThrowOnError>): RequestResult<PostIdentityVerifyTotpEnrollmentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostIdentityVerifyTotpEnrollmentResponses, unknown, ThrowOnError>({
            url: '/identity/totp/verify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteIdentityDeleteTotp<ThrowOnError extends boolean = false>(options?: Options<DeleteIdentityDeleteTotpData, ThrowOnError>): RequestResult<DeleteIdentityDeleteTotpResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).delete<DeleteIdentityDeleteTotpResponses, unknown, ThrowOnError>({ url: '/identity/totp', ...options });
    }
    
    public static getIdentityGetFingerprints<ThrowOnError extends boolean = false>(options?: Options<GetIdentityGetFingerprintsData, ThrowOnError>): RequestResult<GetIdentityGetFingerprintsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetIdentityGetFingerprintsResponses, unknown, ThrowOnError>({ url: '/identity/fingerprints', ...options });
    }
    
    public static postIdentityEnrollFingerprint<ThrowOnError extends boolean = false>(options: Options<PostIdentityEnrollFingerprintData, ThrowOnError>): RequestResult<PostIdentityEnrollFingerprintResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostIdentityEnrollFingerprintResponses, unknown, ThrowOnError>({
            url: '/identity/fingerprint',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteIdentityDeleteFingerprints<ThrowOnError extends boolean = false>(options: Options<DeleteIdentityDeleteFingerprintsData, ThrowOnError>): RequestResult<DeleteIdentityDeleteFingerprintsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteIdentityDeleteFingerprintsResponses, unknown, ThrowOnError>({ url: '/identity/fingerprint/{id}', ...options });
    }
}

export class AuthIdentityCryptoApi {
    public static getIdentityCryptoListCredentials<ThrowOnError extends boolean = false>(options?: Options<GetIdentityCryptoListCredentialsData, ThrowOnError>): RequestResult<GetIdentityCryptoListCredentialsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetIdentityCryptoListCredentialsResponses, unknown, ThrowOnError>({ url: '/identity/crypto/credentials', ...options });
    }
    
    public static postIdentityCryptoRegisterCredential<ThrowOnError extends boolean = false>(options: Options<PostIdentityCryptoRegisterCredentialData, ThrowOnError>): RequestResult<PostIdentityCryptoRegisterCredentialResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostIdentityCryptoRegisterCredentialResponses, unknown, ThrowOnError>({
            url: '/identity/crypto/credentials',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getIdentityCryptoAccountIdentity<ThrowOnError extends boolean = false>(options: Options<GetIdentityCryptoAccountIdentityData, ThrowOnError>): RequestResult<GetIdentityCryptoAccountIdentityResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetIdentityCryptoAccountIdentityResponses, unknown, ThrowOnError>({ url: '/identity/crypto/accounts/{accountId}', ...options });
    }
    
    public static deleteIdentityCryptoDeleteCredential<ThrowOnError extends boolean = false>(options: Options<DeleteIdentityCryptoDeleteCredentialData, ThrowOnError>): RequestResult<DeleteIdentityCryptoDeleteCredentialResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteIdentityCryptoDeleteCredentialResponses, unknown, ThrowOnError>({ url: '/identity/crypto/credentials/{credentialId}', ...options });
    }
    
    public static patchIdentityCryptoUpdateCredentialLabel<ThrowOnError extends boolean = false>(options: Options<PatchIdentityCryptoUpdateCredentialLabelData, ThrowOnError>): RequestResult<PatchIdentityCryptoUpdateCredentialLabelResponses, unknown, ThrowOnError> {
        return (options.client ?? client).patch<PatchIdentityCryptoUpdateCredentialLabelResponses, unknown, ThrowOnError>({
            url: '/identity/crypto/credentials/{credentialId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postIdentityCryptoResetIdentity<ThrowOnError extends boolean = false>(options: Options<PostIdentityCryptoResetIdentityData, ThrowOnError>): RequestResult<PostIdentityCryptoResetIdentityResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostIdentityCryptoResetIdentityResponses, unknown, ThrowOnError>({
            url: '/identity/crypto/reset',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postIdentityCryptoAuthorizeReset<ThrowOnError extends boolean = false>(options: Options<PostIdentityCryptoAuthorizeResetData, ThrowOnError>): RequestResult<PostIdentityCryptoAuthorizeResetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostIdentityCryptoAuthorizeResetResponses, unknown, ThrowOnError>({
            url: '/identity/crypto/reset-authorizations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getIdentityCryptoWrappedKeys<ThrowOnError extends boolean = false>(options: Options<GetIdentityCryptoWrappedKeysData, ThrowOnError>): RequestResult<GetIdentityCryptoWrappedKeysResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetIdentityCryptoWrappedKeysResponses, unknown, ThrowOnError>({ url: '/identity/crypto/credentials/{credentialId}/wrapped-keys', ...options });
    }
    
    public static putIdentityCryptoStoreWrappedKeys<ThrowOnError extends boolean = false>(options: Options<PutIdentityCryptoStoreWrappedKeysData, ThrowOnError>): RequestResult<PutIdentityCryptoStoreWrappedKeysResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutIdentityCryptoStoreWrappedKeysResponses, unknown, ThrowOnError>({
            url: '/identity/crypto/credentials/{credentialId}/wrapped-keys',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getIdentityCryptoCertificate<ThrowOnError extends boolean = false>(options?: Options<GetIdentityCryptoCertificateData, ThrowOnError>): RequestResult<GetIdentityCryptoCertificateResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetIdentityCryptoCertificateResponses, unknown, ThrowOnError>({ url: '/identity/crypto/certificate', ...options });
    }
    
    public static postIdentityCryptoRequestRenewal<ThrowOnError extends boolean = false>(options?: Options<PostIdentityCryptoRequestRenewalData, ThrowOnError>): RequestResult<PostIdentityCryptoRequestRenewalResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostIdentityCryptoRequestRenewalResponses, unknown, ThrowOnError>({ url: '/identity/crypto/certificate/renewals', ...options });
    }
    
    public static postIdentityCryptoRequestRenewalForAccount<ThrowOnError extends boolean = false>(options: Options<PostIdentityCryptoRequestRenewalForAccountData, ThrowOnError>): RequestResult<PostIdentityCryptoRequestRenewalForAccountResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostIdentityCryptoRequestRenewalForAccountResponses, unknown, ThrowOnError>({
            url: '/identity/crypto/certificate/renewals/authority',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthTenantIdentityCryptoApi {
    public static getTenantIdentityCryptoStatus<ThrowOnError extends boolean = false>(options?: Options<GetTenantIdentityCryptoStatusData, ThrowOnError>): RequestResult<GetTenantIdentityCryptoStatusResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTenantIdentityCryptoStatusResponses, unknown, ThrowOnError>({ url: '/tenant/crypto', ...options });
    }
    
    public static postTenantIdentityCryptoInitialize<ThrowOnError extends boolean = false>(options: Options<PostTenantIdentityCryptoInitializeData, ThrowOnError>): RequestResult<PostTenantIdentityCryptoInitializeResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTenantIdentityCryptoInitializeResponses, unknown, ThrowOnError>({
            url: '/tenant/crypto',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getTenantIdentityCryptoRecovery<ThrowOnError extends boolean = false>(options?: Options<GetTenantIdentityCryptoRecoveryData, ThrowOnError>): RequestResult<GetTenantIdentityCryptoRecoveryResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTenantIdentityCryptoRecoveryResponses, unknown, ThrowOnError>({ url: '/tenant/crypto/recovery', ...options });
    }
    
    public static deleteTenantIdentityCryptoRevokeAuthorityGrant<ThrowOnError extends boolean = false>(options: Options<DeleteTenantIdentityCryptoRevokeAuthorityGrantData, ThrowOnError>): RequestResult<DeleteTenantIdentityCryptoRevokeAuthorityGrantResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteTenantIdentityCryptoRevokeAuthorityGrantResponses, unknown, ThrowOnError>({ url: '/tenant/crypto/grants', ...options });
    }
    
    public static getTenantIdentityCryptoListAuthorityGrants<ThrowOnError extends boolean = false>(options?: Options<GetTenantIdentityCryptoListAuthorityGrantsData, ThrowOnError>): RequestResult<GetTenantIdentityCryptoListAuthorityGrantsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTenantIdentityCryptoListAuthorityGrantsResponses, unknown, ThrowOnError>({ url: '/tenant/crypto/grants', ...options });
    }
    
    public static postTenantIdentityCryptoGrant<ThrowOnError extends boolean = false>(options: Options<PostTenantIdentityCryptoGrantData, ThrowOnError>): RequestResult<PostTenantIdentityCryptoGrantResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTenantIdentityCryptoGrantResponses, unknown, ThrowOnError>({
            url: '/tenant/crypto/grants',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getTenantIdentityCryptoListCertificates<ThrowOnError extends boolean = false>(options?: Options<GetTenantIdentityCryptoListCertificatesData, ThrowOnError>): RequestResult<GetTenantIdentityCryptoListCertificatesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTenantIdentityCryptoListCertificatesResponses, unknown, ThrowOnError>({ url: '/tenant/crypto/certificates', ...options });
    }
    
    public static postTenantIdentityCryptoIssueCertificate<ThrowOnError extends boolean = false>(options: Options<PostTenantIdentityCryptoIssueCertificateData, ThrowOnError>): RequestResult<PostTenantIdentityCryptoIssueCertificateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTenantIdentityCryptoIssueCertificateResponses, unknown, ThrowOnError>({
            url: '/tenant/crypto/certificates',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteTenantIdentityCryptoRevokeCertificate<ThrowOnError extends boolean = false>(options: Options<DeleteTenantIdentityCryptoRevokeCertificateData, ThrowOnError>): RequestResult<DeleteTenantIdentityCryptoRevokeCertificateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteTenantIdentityCryptoRevokeCertificateResponses, unknown, ThrowOnError>({ url: '/tenant/crypto/certificates/{fingerprint}', ...options });
    }
    
    public static postTenantIdentityCryptoClaimRenewal<ThrowOnError extends boolean = false>(options?: Options<PostTenantIdentityCryptoClaimRenewalData, ThrowOnError>): RequestResult<PostTenantIdentityCryptoClaimRenewalResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostTenantIdentityCryptoClaimRenewalResponses, unknown, ThrowOnError>({ url: '/tenant/crypto/certificate-renewals/claim', ...options });
    }
    
    public static postTenantIdentityCryptoCompleteRenewal<ThrowOnError extends boolean = false>(options: Options<PostTenantIdentityCryptoCompleteRenewalData, ThrowOnError>): RequestResult<PostTenantIdentityCryptoCompleteRenewalResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTenantIdentityCryptoCompleteRenewalResponses, unknown, ThrowOnError>({
            url: '/tenant/crypto/certificate-renewals/{requestId}/complete',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthAuthApi {
    public static getAuthAuthz<ThrowOnError extends boolean = false>(options?: Options<GetAuthAuthzData, ThrowOnError>): RequestResult<GetAuthAuthzResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetAuthAuthzResponses, unknown, ThrowOnError>({ url: '/authz', ...options });
    }
}

export class AuthAccountsApi {
    public static getAccountsList<ThrowOnError extends boolean = false>(options?: Options<GetAccountsListData, ThrowOnError>): RequestResult<GetAccountsListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetAccountsListResponses, unknown, ThrowOnError>({ url: '/accounts', ...options });
    }
    
    public static postAccountsCreate<ThrowOnError extends boolean = false>(options: Options<PostAccountsCreateData, ThrowOnError>): RequestResult<PostAccountsCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAccountsCreateResponses, unknown, ThrowOnError>({
            url: '/accounts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getAccountsLookup<ThrowOnError extends boolean = false>(options?: Options<GetAccountsLookupData, ThrowOnError>): RequestResult<GetAccountsLookupResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetAccountsLookupResponses, unknown, ThrowOnError>({ url: '/accounts/lookup', ...options });
    }
    
    public static deleteAccountsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteAccountsDeleteData, ThrowOnError>): RequestResult<DeleteAccountsDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteAccountsDeleteResponses, unknown, ThrowOnError>({ url: '/accounts/{id}', ...options });
    }
    
    public static putAccountsUpdate<ThrowOnError extends boolean = false>(options: Options<PutAccountsUpdateData, ThrowOnError>): RequestResult<PutAccountsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutAccountsUpdateResponses, unknown, ThrowOnError>({
            url: '/accounts/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putAccountsUpdatePermissions<ThrowOnError extends boolean = false>(options: Options<PutAccountsUpdatePermissionsData, ThrowOnError>): RequestResult<PutAccountsUpdatePermissionsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutAccountsUpdatePermissionsResponses, unknown, ThrowOnError>({
            url: '/accounts/{id}/permissions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Force-logs-out an account's sessions (tenant admin, scoped to accounts in the caller's own tenant). The default — no body, or `{}` — ends every active session on every platform (`keepLast: 0`, no endpointType/platformSubtype filter): the same primitive account deletion uses. Optionally scope to one platform (and, for 'device', one form factor) and/or keep the N most-recently-used matching sessions instead of ending all of them. Sessions aren't tenant-scoped, so this ends the account's sessions everywhere, not just within the caller's tenant.
     */
    public static postAccountsForceLogout<ThrowOnError extends boolean = false>(options: Options<PostAccountsForceLogoutData, ThrowOnError>): RequestResult<PostAccountsForceLogoutResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAccountsForceLogoutResponses, unknown, ThrowOnError>({
            url: '/accounts/{id}/force-logout',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthRolesApi {
    public static getRolesList<ThrowOnError extends boolean = false>(options?: Options<GetRolesListData, ThrowOnError>): RequestResult<GetRolesListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetRolesListResponses, unknown, ThrowOnError>({ url: '/roles', ...options });
    }
    
    public static postRolesCreate<ThrowOnError extends boolean = false>(options: Options<PostRolesCreateData, ThrowOnError>): RequestResult<PostRolesCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostRolesCreateResponses, unknown, ThrowOnError>({
            url: '/roles',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteRolesDelete<ThrowOnError extends boolean = false>(options: Options<DeleteRolesDeleteData, ThrowOnError>): RequestResult<DeleteRolesDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteRolesDeleteResponses, unknown, ThrowOnError>({ url: '/roles/{id}', ...options });
    }
    
    public static putRolesUpdate<ThrowOnError extends boolean = false>(options: Options<PutRolesUpdateData, ThrowOnError>): RequestResult<PutRolesUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutRolesUpdateResponses, unknown, ThrowOnError>({
            url: '/roles/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putRolesUpdatePermissions<ThrowOnError extends boolean = false>(options: Options<PutRolesUpdatePermissionsData, ThrowOnError>): RequestResult<PutRolesUpdatePermissionsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutRolesUpdatePermissionsResponses, unknown, ThrowOnError>({
            url: '/roles/{id}/permissions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthWorkstationsApi {
    public static getWorkstationsIndex<ThrowOnError extends boolean = false>(options?: Options<GetWorkstationsIndexData, ThrowOnError>): RequestResult<GetWorkstationsIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetWorkstationsIndexResponses, unknown, ThrowOnError>({ url: '/workstations', ...options });
    }
    
    /**
     * Register a workstation from a handshake. `accountSpecific: true` binds THIS machine to the authenticated caller (single-account): it's then permanently signed in as that account — no further per-use auth (auth-credentials/ auth-fp reject bound machines) — and the call returns a login session that just keeps renewing via /login/renew. A tenant policy must allow authenticated accounts to bind their own machine. Otherwise it's a shared enrolment (admin only, accountId null), returning `{ ok: true }`.
     */
    public static postWorkstationsCreate<ThrowOnError extends boolean = false>(options: Options<PostWorkstationsCreateData, ThrowOnError>): RequestResult<PostWorkstationsCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostWorkstationsCreateResponses, unknown, ThrowOnError>({
            url: '/workstations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Resolve workstation display names by id for the tenant. The suite frontend knows workstations only by id (suite dropped the name); it calls this to label them. Any authenticated tenant member — not admin-only — since names are shown on non-admin screens too. Unknown/foreign-tenant ids are silently omitted.
     */
    public static getWorkstationsResolveNames<ThrowOnError extends boolean = false>(options?: Options<GetWorkstationsResolveNamesData, ThrowOnError>): RequestResult<GetWorkstationsResolveNamesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetWorkstationsResolveNamesResponses, unknown, ThrowOnError>({ url: '/workstations/resolve-names', ...options });
    }
    
    /**
     * Create a pending shared-workstation enrolment and return a short registration code for the workstation to redeem.
     */
    public static postWorkstationsCreateRegistration<ThrowOnError extends boolean = false>(options: Options<PostWorkstationsCreateRegistrationData, ThrowOnError>): RequestResult<PostWorkstationsCreateRegistrationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostWorkstationsCreateRegistrationResponses, unknown, ThrowOnError>({
            url: '/workstations/registrations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Redeem an admin-issued registration code with a workstation handshake, provisioning a shared (tenant-bound, accountId-null) workstation. No admin SSO at the machine is required. Atomic: the registration is locked FOR UPDATE so two workstations can't redeem the same code.
     */
    public static postWorkstationsRegister<ThrowOnError extends boolean = false>(options: Options<PostWorkstationsRegisterData, ThrowOnError>): RequestResult<PostWorkstationsRegisterResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostWorkstationsRegisterResponses, unknown, ThrowOnError>({
            url: '/workstations/register',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Remove a workstation: propagate the delete to suite first (which soft-deletes the suite workstation and everything under it — devices, their paper sizes, preferences), then soft-delete it here and log out its active session (its next renewal then fails), and notify admins. Suite is called FIRST and hard-fails (503) so an unreachable suite never leaves the workstation deleted in auth but still live in suite — the admin just retries. Once the delete is committed, bridge is notified best-effort so it can drop any still-connected workstation socket.
     */
    public static deleteWorkstationsRemove<ThrowOnError extends boolean = false>(options: Options<DeleteWorkstationsRemoveData, ThrowOnError>): RequestResult<DeleteWorkstationsRemoveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteWorkstationsRemoveResponses, unknown, ThrowOnError>({ url: '/workstations/{id}', ...options });
    }
    
    /**
     * Admin edit of a workstation. `name` updates the display name (tenant-unique, owned by auth — suite only knows the id). `idleTimeoutSeconds` is the idle hint (seconds before the client self-logs-out); `null` disables it, otherwise it must be between MIN and MAX. Not enforced server-side — returned in login/renewal. Either field may be omitted to leave it unchanged.
     */
    public static putWorkstationsUpdate<ThrowOnError extends boolean = false>(options: Options<PutWorkstationsUpdateData, ThrowOnError>): RequestResult<PutWorkstationsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutWorkstationsUpdateResponses, unknown, ThrowOnError>({
            url: '/workstations/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postWorkstationsDetectWorkstation<ThrowOnError extends boolean = false>(options: Options<PostWorkstationsDetectWorkstationData, ThrowOnError>): RequestResult<PostWorkstationsDetectWorkstationResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostWorkstationsDetectWorkstationResponses, unknown, ThrowOnError>({
            url: '/workstations/detect-workstation',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postWorkstationsAuthCredentials<ThrowOnError extends boolean = false>(options: Options<PostWorkstationsAuthCredentialsData, ThrowOnError>): RequestResult<PostWorkstationsAuthCredentialsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostWorkstationsAuthCredentialsResponses, unknown, ThrowOnError>({
            url: '/workstations/auth-credentials',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postWorkstationsAuthFp<ThrowOnError extends boolean = false>(options: Options<PostWorkstationsAuthFpData, ThrowOnError>): RequestResult<PostWorkstationsAuthFpResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostWorkstationsAuthFpResponses, unknown, ThrowOnError>({
            url: '/workstations/auth-fp',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthProxyOidcApi {
    public static postProxyOidcGenerateStartUrl<ThrowOnError extends boolean = false>(options: Options<PostProxyOidcGenerateStartUrlData, ThrowOnError>): RequestResult<PostProxyOidcGenerateStartUrlResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostProxyOidcGenerateStartUrlResponses, unknown, ThrowOnError>({
            url: '/proxy-oidc/generate-start-url',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postProxyOidcStart<ThrowOnError extends boolean = false>(options: Options<PostProxyOidcStartData, ThrowOnError>): RequestResult<PostProxyOidcStartResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostProxyOidcStartResponses, unknown, ThrowOnError>({
            url: '/proxy-oidc/start',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getProxyOidcCallback<ThrowOnError extends boolean = false>(options: Options<GetProxyOidcCallbackData, ThrowOnError>): RequestResult<GetProxyOidcCallbackResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetProxyOidcCallbackResponses, unknown, ThrowOnError>({ url: '/proxy-oidc/callback', ...options });
    }
    
    public static postProxyOidcRenew<ThrowOnError extends boolean = false>(options?: Options<PostProxyOidcRenewData, ThrowOnError>): RequestResult<PostProxyOidcRenewResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostProxyOidcRenewResponses, unknown, ThrowOnError>({ url: '/proxy-oidc/renew', ...options });
    }
}

export class AuthIdpConfigApi {
    public static getIdpConfigGetIdpConfig<ThrowOnError extends boolean = false>(options?: Options<GetIdpConfigGetIdpConfigData, ThrowOnError>): RequestResult<GetIdpConfigGetIdpConfigResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetIdpConfigGetIdpConfigResponses, unknown, ThrowOnError>({ url: '/idp/config', ...options });
    }
    
    public static postIdpConfigSetupIdpConfig<ThrowOnError extends boolean = false>(options: Options<PostIdpConfigSetupIdpConfigData, ThrowOnError>): RequestResult<PostIdpConfigSetupIdpConfigResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostIdpConfigSetupIdpConfigResponses, unknown, ThrowOnError>({
            url: '/idp/config/setup',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postIdpConfigCompleteIdpSetup<ThrowOnError extends boolean = false>(options: Options<PostIdpConfigCompleteIdpSetupData, ThrowOnError>): RequestResult<PostIdpConfigCompleteIdpSetupResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostIdpConfigCompleteIdpSetupResponses, unknown, ThrowOnError>({
            url: '/idp/config/complete-setup',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postIdpConfigUnlinkIdp<ThrowOnError extends boolean = false>(options?: Options<PostIdpConfigUnlinkIdpData, ThrowOnError>): RequestResult<PostIdpConfigUnlinkIdpResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostIdpConfigUnlinkIdpResponses, unknown, ThrowOnError>({ url: '/idp/config/unlink', ...options });
    }
}

export class AuthIdpApi {
    public static getIdpListAccounts<ThrowOnError extends boolean = false>(options?: Options<GetIdpListAccountsData, ThrowOnError>): RequestResult<GetIdpListAccountsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetIdpListAccountsResponses, unknown, ThrowOnError>({ url: '/idp/accounts', ...options });
    }
    
    public static postIdpImportMatchedAccounts<ThrowOnError extends boolean = false>(options?: Options<PostIdpImportMatchedAccountsData, ThrowOnError>): RequestResult<PostIdpImportMatchedAccountsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostIdpImportMatchedAccountsResponses, unknown, ThrowOnError>({ url: '/idp/import-matched', ...options });
    }
}

export class AuthMspApi {
    public static getMspGetMspTenants<ThrowOnError extends boolean = false>(options?: Options<GetMspGetMspTenantsData, ThrowOnError>): RequestResult<GetMspGetMspTenantsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetMspGetMspTenantsResponses, unknown, ThrowOnError>({ url: '/msp/tenants', ...options });
    }
}

export class AuthOidcDiscoveryApi {
    public static getOidcDiscoveryGetOidcConfiguration<ThrowOnError extends boolean = false>(options?: Options<GetOidcDiscoveryGetOidcConfigurationData, ThrowOnError>): RequestResult<GetOidcDiscoveryGetOidcConfigurationResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetOidcDiscoveryGetOidcConfigurationResponses, unknown, ThrowOnError>({ url: '/.well-known/openid-configuration', ...options });
    }
    
    public static getOidcDiscoveryGetJwks<ThrowOnError extends boolean = false>(options?: Options<GetOidcDiscoveryGetJwksData, ThrowOnError>): RequestResult<GetOidcDiscoveryGetJwksResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetOidcDiscoveryGetJwksResponses, unknown, ThrowOnError>({ url: '/.well-known/jwks.json', ...options });
    }
}

export class AuthPublicMspApi {
    public static getPublicMspGetMspInfo<ThrowOnError extends boolean = false>(options: Options<GetPublicMspGetMspInfoData, ThrowOnError>): RequestResult<GetPublicMspGetMspInfoResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetPublicMspGetMspInfoResponses, unknown, ThrowOnError>({ url: '/public/msp/info', ...options });
    }
}

export class AuthPermissionsApi {
    public static getPermissionsGet<ThrowOnError extends boolean = false>(options?: Options<GetPermissionsGetData, ThrowOnError>): RequestResult<GetPermissionsGetResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetPermissionsGetResponses, unknown, ThrowOnError>({ url: '/permissions', ...options });
    }
}

export class AuthRpcApi {
    /**
     * Signs a payload for an authenticated frontend identity. This stays on the HTTP RPC controller (it is identity-scoped and called by the frontend); the backend-to-backend RPC methods moved to zrpc (see AuthZrpcHandlers).
     */
    public static postRpcSignRpcPayload<ThrowOnError extends boolean = false>(options: Options<PostRpcSignRpcPayloadData, ThrowOnError>): RequestResult<PostRpcSignRpcPayloadResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostRpcSignRpcPayloadResponses, unknown, ThrowOnError>({
            url: '/rpc/sign',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthSaAccountsApi {
    public static getSaAccountsGet<ThrowOnError extends boolean = false>(options: Options<GetSaAccountsGetData, ThrowOnError>): RequestResult<GetSaAccountsGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSaAccountsGetResponses, unknown, ThrowOnError>({ url: '/sa/accounts/{id}', ...options });
    }
    
    /**
     * Raises the account's session cap for one or more platform types above the platform default of 1 (e.g. `{ phone: 2 }` for someone who legitimately needs both a personal iPhone and Android session). `customSessionLimits: null` resets the account back to the platform defaults.
     */
    public static putSaAccountsSetSessionLimits<ThrowOnError extends boolean = false>(options: Options<PutSaAccountsSetSessionLimitsData, ThrowOnError>): RequestResult<PutSaAccountsSetSessionLimitsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSaAccountsSetSessionLimitsResponses, unknown, ThrowOnError>({
            url: '/sa/accounts/{id}/session-limits',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthSaPermissionBoundariesApi {
    public static getSaPermissionBoundariesGetCatalog<ThrowOnError extends boolean = false>(options?: Options<GetSaPermissionBoundariesGetCatalogData, ThrowOnError>): RequestResult<GetSaPermissionBoundariesGetCatalogResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSaPermissionBoundariesGetCatalogResponses, unknown, ThrowOnError>({ url: '/sa/permission-boundaries/catalog', ...options });
    }
}

export class AuthSaPermissionBoundarySetsApi {
    public static getSaPermissionBoundarySetsList<ThrowOnError extends boolean = false>(options?: Options<GetSaPermissionBoundarySetsListData, ThrowOnError>): RequestResult<GetSaPermissionBoundarySetsListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSaPermissionBoundarySetsListResponses, unknown, ThrowOnError>({ url: '/sa/permission-boundary-sets', ...options });
    }
    
    public static postSaPermissionBoundarySetsCreate<ThrowOnError extends boolean = false>(options: Options<PostSaPermissionBoundarySetsCreateData, ThrowOnError>): RequestResult<PostSaPermissionBoundarySetsCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSaPermissionBoundarySetsCreateResponses, unknown, ThrowOnError>({
            url: '/sa/permission-boundary-sets',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteSaPermissionBoundarySetsRemove<ThrowOnError extends boolean = false>(options: Options<DeleteSaPermissionBoundarySetsRemoveData, ThrowOnError>): RequestResult<DeleteSaPermissionBoundarySetsRemoveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteSaPermissionBoundarySetsRemoveResponses, unknown, ThrowOnError>({ url: '/sa/permission-boundary-sets/{id}', ...options });
    }
    
    public static getSaPermissionBoundarySetsGet<ThrowOnError extends boolean = false>(options: Options<GetSaPermissionBoundarySetsGetData, ThrowOnError>): RequestResult<GetSaPermissionBoundarySetsGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSaPermissionBoundarySetsGetResponses, unknown, ThrowOnError>({ url: '/sa/permission-boundary-sets/{id}', ...options });
    }
    
    public static putSaPermissionBoundarySetsUpdate<ThrowOnError extends boolean = false>(options: Options<PutSaPermissionBoundarySetsUpdateData, ThrowOnError>): RequestResult<PutSaPermissionBoundarySetsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSaPermissionBoundarySetsUpdateResponses, unknown, ThrowOnError>({
            url: '/sa/permission-boundary-sets/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getSaPermissionBoundarySetsHistory<ThrowOnError extends boolean = false>(options: Options<GetSaPermissionBoundarySetsHistoryData, ThrowOnError>): RequestResult<GetSaPermissionBoundarySetsHistoryResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSaPermissionBoundarySetsHistoryResponses, unknown, ThrowOnError>({ url: '/sa/permission-boundary-sets/{id}/history', ...options });
    }
}

export class AuthSaTenantPermissionBoundaryApi {
    public static getSaTenantPermissionBoundaryGet<ThrowOnError extends boolean = false>(options: Options<GetSaTenantPermissionBoundaryGetData, ThrowOnError>): RequestResult<GetSaTenantPermissionBoundaryGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSaTenantPermissionBoundaryGetResponses, unknown, ThrowOnError>({ url: '/sa/tenants/{tenantId}/permissions-boundary', ...options });
    }
    
    public static patchSaTenantPermissionBoundaryPatch<ThrowOnError extends boolean = false>(options: Options<PatchSaTenantPermissionBoundaryPatchData, ThrowOnError>): RequestResult<PatchSaTenantPermissionBoundaryPatchResponses, unknown, ThrowOnError> {
        return (options.client ?? client).patch<PatchSaTenantPermissionBoundaryPatchResponses, unknown, ThrowOnError>({
            url: '/sa/tenants/{tenantId}/permissions-boundary',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putSaTenantPermissionBoundaryReplace<ThrowOnError extends boolean = false>(options: Options<PutSaTenantPermissionBoundaryReplaceData, ThrowOnError>): RequestResult<PutSaTenantPermissionBoundaryReplaceResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSaTenantPermissionBoundaryReplaceResponses, unknown, ThrowOnError>({
            url: '/sa/tenants/{tenantId}/permissions-boundary',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postSaTenantPermissionBoundaryApplySet<ThrowOnError extends boolean = false>(options: Options<PostSaTenantPermissionBoundaryApplySetData, ThrowOnError>): RequestResult<PostSaTenantPermissionBoundaryApplySetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSaTenantPermissionBoundaryApplySetResponses, unknown, ThrowOnError>({
            url: '/sa/tenants/{tenantId}/permissions-boundary/apply-set',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getSaTenantPermissionBoundaryHistory<ThrowOnError extends boolean = false>(options: Options<GetSaTenantPermissionBoundaryHistoryData, ThrowOnError>): RequestResult<GetSaTenantPermissionBoundaryHistoryResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSaTenantPermissionBoundaryHistoryResponses, unknown, ThrowOnError>({ url: '/sa/tenants/{tenantId}/permissions-boundary/history', ...options });
    }
}

export class AuthSaTenantsApi {
    public static getSaTenantsList<ThrowOnError extends boolean = false>(options?: Options<GetSaTenantsListData, ThrowOnError>): RequestResult<GetSaTenantsListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSaTenantsListResponses, unknown, ThrowOnError>({ url: '/sa/tenants', ...options });
    }
    
    public static postSaTenantsCreate<ThrowOnError extends boolean = false>(options: Options<PostSaTenantsCreateData, ThrowOnError>): RequestResult<PostSaTenantsCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSaTenantsCreateResponses, unknown, ThrowOnError>({
            url: '/sa/tenants',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteSaTenantsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteSaTenantsDeleteData, ThrowOnError>): RequestResult<DeleteSaTenantsDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteSaTenantsDeleteResponses, unknown, ThrowOnError>({ url: '/sa/tenants/{id}', ...options });
    }
    
    public static getSaTenantsGet<ThrowOnError extends boolean = false>(options: Options<GetSaTenantsGetData, ThrowOnError>): RequestResult<GetSaTenantsGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSaTenantsGetResponses, unknown, ThrowOnError>({ url: '/sa/tenants/{id}', ...options });
    }
    
    public static putSaTenantsUpdate<ThrowOnError extends boolean = false>(options: Options<PutSaTenantsUpdateData, ThrowOnError>): RequestResult<PutSaTenantsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSaTenantsUpdateResponses, unknown, ThrowOnError>({
            url: '/sa/tenants/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthScopedTokensApi {
    public static getScopedTokensList<ThrowOnError extends boolean = false>(options?: Options<GetScopedTokensListData, ThrowOnError>): RequestResult<GetScopedTokensListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetScopedTokensListResponses, unknown, ThrowOnError>({ url: '/identity/scoped-tokens', ...options });
    }
    
    public static postScopedTokensCreate<ThrowOnError extends boolean = false>(options: Options<PostScopedTokensCreateData, ThrowOnError>): RequestResult<PostScopedTokensCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostScopedTokensCreateResponses, unknown, ThrowOnError>({
            url: '/identity/scoped-tokens',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postScopedTokensRenew<ThrowOnError extends boolean = false>(options: Options<PostScopedTokensRenewData, ThrowOnError>): RequestResult<PostScopedTokensRenewResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostScopedTokensRenewResponses, unknown, ThrowOnError>({
            url: '/identity/scoped-tokens/renew',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postScopedTokensRevokeSelf<ThrowOnError extends boolean = false>(options?: Options<PostScopedTokensRevokeSelfData, ThrowOnError>): RequestResult<PostScopedTokensRevokeSelfResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostScopedTokensRevokeSelfResponses, unknown, ThrowOnError>({ url: '/identity/scoped-tokens/revoke', ...options });
    }
    
    public static deleteScopedTokensRevoke<ThrowOnError extends boolean = false>(options: Options<DeleteScopedTokensRevokeData, ThrowOnError>): RequestResult<DeleteScopedTokensRevokeResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteScopedTokensRevokeResponses, unknown, ThrowOnError>({ url: '/identity/scoped-tokens/{id}', ...options });
    }
}

export class AuthTenantApi {
    public static getTenantGet<ThrowOnError extends boolean = false>(options?: Options<GetTenantGetData, ThrowOnError>): RequestResult<GetTenantGetResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTenantGetResponses, unknown, ThrowOnError>({ url: '/tenant', ...options });
    }
    
    public static getTenantGetConfig<ThrowOnError extends boolean = false>(options?: Options<GetTenantGetConfigData, ThrowOnError>): RequestResult<GetTenantGetConfigResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTenantGetConfigResponses, unknown, ThrowOnError>({ url: '/tenant/config', ...options });
    }
    
    public static putTenantUpdateConfig<ThrowOnError extends boolean = false>(options: Options<PutTenantUpdateConfigData, ThrowOnError>): RequestResult<PutTenantUpdateConfigResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutTenantUpdateConfigResponses, unknown, ThrowOnError>({
            url: '/tenant/config',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Lets a native tenant administrator opt their currently independent tenant into an MSP relationship.
     */
    public static postTenantAssociateMsp<ThrowOnError extends boolean = false>(options: Options<PostTenantAssociateMspData, ThrowOnError>): RequestResult<PostTenantAssociateMspResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTenantAssociateMspResponses, unknown, ThrowOnError>({
            url: '/tenant/msp-association',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthTenantApiKeysApi {
    public static getTenantApiKeysList<ThrowOnError extends boolean = false>(options?: Options<GetTenantApiKeysListData, ThrowOnError>): RequestResult<GetTenantApiKeysListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTenantApiKeysListResponses, unknown, ThrowOnError>({ url: '/tenant/api-keys', ...options });
    }
    
    public static postTenantApiKeysCreate<ThrowOnError extends boolean = false>(options: Options<PostTenantApiKeysCreateData, ThrowOnError>): RequestResult<PostTenantApiKeysCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTenantApiKeysCreateResponses, unknown, ThrowOnError>({
            url: '/tenant/api-keys',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteTenantApiKeysRemove<ThrowOnError extends boolean = false>(options: Options<DeleteTenantApiKeysRemoveData, ThrowOnError>): RequestResult<DeleteTenantApiKeysRemoveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteTenantApiKeysRemoveResponses, unknown, ThrowOnError>({ url: '/tenant/api-keys/{id}', ...options });
    }
    
    public static putTenantApiKeysUpdate<ThrowOnError extends boolean = false>(options: Options<PutTenantApiKeysUpdateData, ThrowOnError>): RequestResult<PutTenantApiKeysUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutTenantApiKeysUpdateResponses, unknown, ThrowOnError>({
            url: '/tenant/api-keys/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthTenantPublishableKeysApi {
    public static getTenantPublishableKeysList<ThrowOnError extends boolean = false>(options?: Options<GetTenantPublishableKeysListData, ThrowOnError>): RequestResult<GetTenantPublishableKeysListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetTenantPublishableKeysListResponses, unknown, ThrowOnError>({ url: '/tenant/publishable-keys', ...options });
    }
    
    public static postTenantPublishableKeysCreate<ThrowOnError extends boolean = false>(options: Options<PostTenantPublishableKeysCreateData, ThrowOnError>): RequestResult<PostTenantPublishableKeysCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTenantPublishableKeysCreateResponses, unknown, ThrowOnError>({
            url: '/tenant/publishable-keys',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteTenantPublishableKeysRemove<ThrowOnError extends boolean = false>(options: Options<DeleteTenantPublishableKeysRemoveData, ThrowOnError>): RequestResult<DeleteTenantPublishableKeysRemoveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteTenantPublishableKeysRemoveResponses, unknown, ThrowOnError>({ url: '/tenant/publishable-keys/{id}', ...options });
    }
    
    public static putTenantPublishableKeysUpdate<ThrowOnError extends boolean = false>(options: Options<PutTenantPublishableKeysUpdateData, ThrowOnError>): RequestResult<PutTenantPublishableKeysUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutTenantPublishableKeysUpdateResponses, unknown, ThrowOnError>({
            url: '/tenant/publishable-keys/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthPushTokenApi {
    public static postPushTokenRegisterPushToken<ThrowOnError extends boolean = false>(options: Options<PostPushTokenRegisterPushTokenData, ThrowOnError>): RequestResult<PostPushTokenRegisterPushTokenResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostPushTokenRegisterPushTokenResponses, unknown, ThrowOnError>({
            url: '/push-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthSseApi {
    public static getSseGetStream<ThrowOnError extends boolean = false>(options?: Options<GetSseGetStreamData, ThrowOnError>): RequestResult<GetSseGetStreamResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSseGetStreamResponses, unknown, ThrowOnError>({ url: '/sse', ...options });
    }
}

export class AuthZynoRpcApi {
    public static postZynoRpcDispatch<ThrowOnError extends boolean = false>(options: Options<PostZynoRpcDispatchData, ThrowOnError>): RequestResult<PostZynoRpcDispatchResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostZynoRpcDispatchResponses, unknown, ThrowOnError>({ url: '/zrpc/{svc}/{method}', ...options });
    }
}
